import { http } from "../../../services/http.service";
import { UserLoginModel } from "../models/user-login.model";
import { UserResetPasswordModel } from "../models/user-reset-password.model";

export const loginApi = (data: UserLoginModel) =>
  http({ url: "login", method: "POST", auth: false, data });
export const resetPasswordApi = (data: UserResetPasswordModel) =>
  http({ url: "reset-password", method: "POST", auth: false, data });
